module.exports = __webpack_public_path__ + "img/central-klaus-1.7f829a1c.png";